import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/Auth/AuthContext";

const ProtectedRoutes = ({ children }) => {
	const { auth } = useAuth();
	const location = useLocation();

	return auth ? (
		children
	) : (
		<Navigate to="/login" replace={true} state={{ from: location }} />
	);
};

export default ProtectedRoutes;
